<section class="dashboard-chart-section">
  @for (chart of chartsData; track chart) {
    <div class="chart-container">
      <h3 class="chart-title">{{ chart.title }}</h3>
      <highcharts-chart [Highcharts]="highcharts" [options]="chart.options"></highcharts-chart>
    </div>
  }
</section>
